// extracted by mini-css-extract-plugin
export var body = "default-module--body--76bc8";
export var footer = "default-module--footer--f1198";
export var outer = "default-module--outer--29a77";